import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { BaseService } from './base.service';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import { ApiS3Service } from './api-s3.service';
import { PlatformService } from './platform.service';
import { ApiInfocapebsVindiService } from './api-infocapebs-vindi.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FiltroControllerService } from './filtro-controller.service';
import { ModelStatusPagamento } from '../models/status-pagamento.model';
import * as Moment from 'moment';
import { TokenInterceptorService } from './token-interceptor.service';
import { firstValueFrom, of } from 'rxjs';
import { delay, retryWhen, tap } from 'rxjs/operators';
import { UtilsService } from 'src/app/services/utils.service';

@Injectable({
	providedIn: 'root'
})
export class ApiUsuarioService {

	STATUS = new ModelStatusPagamento();
	private ENV: any = environment;
	private URL;
	private hashLogin = 'ea496a8fe1b7d512c22029e679f0f2f9';
	private cryptK = 'dfsghjd__FGghf#sgwerShk453troic#5';
	private assinaturaId;
	private credenciais;
	private credenciaisPDocs;
	primeiroTeste = true;
	forceRefresh: boolean = false;
	deslogandoSessao: BehaviorSubject<boolean>;
	avatar;
	avatares = {};
	listaUsuarios = [];
	moment = Moment;
	parceiroItauSubject = new BehaviorSubject(false);
	parceiroItau = this.parceiroItauSubject.asObservable();
	autenticado: BehaviorSubject<boolean>;
	statusPagamento: BehaviorSubject<boolean>;
	refreshListaTarefas: BehaviorSubject<boolean>;
	corretorasNaoRedirecionadas = ["7f78915e-18fb-4e71-81ba-f9068ac6c025", "ce1b2903-a0a8-499d-81f5-ff8b4e9d698f", "4d3f88bf-d4ce-4a9c-8fc2-bedfedce5e92"]

	pathHistory = '/dashboard';

	constructor(private http: HttpClient, private BS: BaseService, private plataform: PlatformService, private apiEbs: ApiInfocapebsVindiService, private snack: MatSnackBar, public filtroController: FiltroControllerService, public utilsService: UtilsService) {
		this.URL = this.ENV.apice.url;
		this.autenticado = new BehaviorSubject<boolean>(false);
		this.statusPagamento = new BehaviorSubject<boolean>(false);
		this.deslogandoSessao = new BehaviorSubject<boolean>(false);
		this.refreshListaTarefas = new BehaviorSubject<boolean>(false);

		this.plataform.deviceType = this.plataform.deviceType != 'desktop' ? 'mobile' : this.plataform.deviceType;
	}

	login(body) {
		return this.http.post(this.URL + `usuario/login?device=${this.plataform.deviceType}`, body, this.BS.getHeaders()).toPromise();
	}

  async getListCfgsSegs() {

    let result: any = await this.http.get(this.URL + 'cfg/seguradora/config', this.BS.getHeaders(true)).toPromise();

    return result

  }

	loginRoot(body) {
		return this.http.post(this.URL + 'usuario/acessaUsuarioCliente', body, this.BS.getHeaders(true)).toPromise();
	}

	refreshToken(body) {
		return this.http.post(this.URL + `usuario/login?device=${this.plataform.deviceType}`, body, this.BS.getHeaders());
	}

	redefinirSenha(body) {
		return this.http.post(this.URL + 'usuario/redefinir_senha/mudar_senha', body, this.BS.getHeaders()).toPromise();
	}

	solicitaRedefinirSenhaPorEmail(email): Promise<any> {
		return this.http.post(this.URL + 'usuario/solicita_redefinir_senha', { email: email }, this.BS.getHeaders()).toPromise();
	}

	verificaUsuario(email: string, usuarioId?) {
		return this.http.get(this.URL + `usuario/verificacao?email=${email}`).toPromise();
	}

	//Salva o login criptografado no armazenamento local.
	armazenaLogin(login) {
			let loginStr = JSON.stringify(login);
			loginStr = CryptoJS.AES.encrypt(loginStr, this.cryptK).toString();
			localStorage.setItem(this.hashLogin, loginStr);
			this.credenciais = login;
			delete this.credenciais.senha;
			this.armazenaAssinaturaId(this.credenciais.assinaturaId);
			this.listaUsuarios = [];
			this.buscaUsuarios2();
	}

	//BUSCA credenciais do apice
	getCredenciais() {
		if (this.credenciais) {
			if (!this.autenticado.value) { this.autenticado.next(true) }
			return this.credenciais;
		} else if (localStorage.getItem(this.hashLogin)) {
			let login = localStorage.getItem(this.hashLogin);
			let loginStr = CryptoJS.AES.decrypt(login, this.cryptK).toString(CryptoJS.enc.Utf8);
			if (!this.autenticado.value) { this.autenticado.next(true) }
			this.credenciais = JSON.parse(loginStr);
			return this.credenciais;
		} else {
			this.autenticado.next(false);
			return false;
		}
	}

	getDataMonitor(data) {
		let dados = CryptoJS.AES.decrypt(data, this.cryptK).toString(CryptoJS.enc.Utf8);
		return dados;
	}

	getCredenciaisCrypto() {
		if (localStorage.getItem(this.hashLogin)) {
			let login = localStorage.getItem(this.hashLogin);
			let loginStr = CryptoJS.AES.decrypt(login, this.cryptK).toString(CryptoJS.enc.Utf8);
			this.autenticado.next(true);
			return JSON.parse(loginStr);
		}
	}

	armazenaAssinaturaId(assinaturaId) {
		if (assinaturaId) {
			this.assinaturaId = assinaturaId;
			localStorage.setItem('assinaturaId', JSON.stringify(assinaturaId));
			// this.getAssinaturaId();
		}
	}

	assinaturaUser
	async getAssinaturaId() {
		if (this.assinaturaId && this.assinaturaId.length) {
			try {
				let assinaturaVigente = this.assinaturaId.find(assinatura => assinatura?.situacao == 1);
				if (!assinaturaVigente) {
					assinaturaVigente = this.assinaturaId?.[0];
				}
				let assinaturaVindi: any = await this.apiEbs.getAssinatura(assinaturaVigente.id)
				this.parceiroItauSubject.next(assinaturaVindi.plano.code == "APC-VIP-MENSAL")
				let dtStartSubscribe = assinaturaVindi?.periodo_atual?.start_at;
				this.assinaturaUser = {
					assinatura: assinaturaVindi,
					dataStartAss: dtStartSubscribe
				}
			} catch (error) {
				console.log(error)
				return error
			}
		} else if (JSON.parse(localStorage.getItem('assinaturaId')) && JSON.parse(localStorage.getItem('assinaturaId')).length) {
			try {
				let assinaturaId: any = JSON.parse(localStorage.getItem('assinaturaId'));
				if (assinaturaId.length) {
					let assinaturaVigente = assinaturaId.find(assinatura => assinatura?.situacao == 1);
					if (!assinaturaVigente) {
						assinaturaVigente = this.assinaturaId?.[0];
					}
					debugger
					let assinaturaVindi: any = await this.apiEbs.getAssinatura(assinaturaVigente.id)
					this.parceiroItauSubject.next(assinaturaVindi.plano.code == "APC-VIP-MENSAL")
					let dtStartSubscribe = assinaturaVindi?.periodo_atual?.start_at;
					this.assinaturaUser = {
						assinatura: assinaturaVindi,
						dataStartAss: dtStartSubscribe
					}
				}
			} catch (error) {
				console.log(error)
				return error
			}
		} else {
			this.assinaturaUser = 'Sem assinatura'
		}

		// console.log(this.assinaturaUser)
	}

	putDataCredenciais(nome?, email?) {
		let credenciais = this.getCredenciaisCrypto();
		if (credenciais) {
			credenciais.nome = nome;
			credenciais.email = email;
			this.armazenaLogin(credenciais);
		}
	}

	deslogar() {
		this.credenciais = this.getCredenciais();
		if (this.credenciais) {
			this.deslogandoSessao.next(true);
			let idSessao = this.credenciais.idSessao;
			this.deslogaSessao({ idSessao: idSessao, token: this.credenciais.token })
				.then((response) => {
					console.log('apagou sessão')
					localStorage.removeItem(this.hashLogin);
					localStorage.removeItem('assinaturaId');
					this.apiEbs.assinaturaApiceDb = null;
					this.apiEbs.assinaturaVindi = null;
					this.apiEbs.promisseAssinaturaVindi = new Map();
 					this.apiEbs.promiseEmAndamento = null;
					this.parceiroItauSubject.next(false);
					this.primeiroTeste = true;
					this.autenticado.next(false);
					this.credenciais = null;
					this.credenciaisPDocs = null;
					this.assinaturaUser = null;
				})
				.catch((error) => { console.log(error) })
				.finally(() => {
					localStorage.removeItem(this.hashLogin);
					localStorage.removeItem('assinaturaId');
					this.autenticado.next(false);
					this.credenciais = null;
					this.apiEbs.assinaturaApiceDb = null;
					this.parceiroItauSubject.next(false);
					this.apiEbs.assinaturaVindi = null;
					this.credenciaisPDocs = null;
					this.assinaturaUser = null;
					this.deslogandoSessao.next(false);
				})
			localStorage.removeItem(this.hashLogin);
			localStorage.removeItem('assinaturaId');
			this.autenticado.next(false);
			this.credenciais = null;
			this.credenciaisPDocs = null;
			this.assinaturaUser = null;
		}
		this.listaUsuarios = [];
	}

	deslogaSessao(body) {
		this.filtroController.clearFilterLS();
		let headers = {
			'Content-Type': 'application/json',
			'Authorization': body.token
		};
		let reqOpts = { headers: new HttpHeaders(headers) }
		return this.http.post(this.URL + 'usuario/deslogaSessao', body, reqOpts).toPromise();
	}

	buscaUsuarios() {
		return this.http.get(this.URL + 'usuario/listaUsuarios', this.BS.getHeaders(true)).toPromise();
	}
	promisePending = false;
	intervalGetUsuarios;
	countIntervalUsuarios = 0;


async buscaUsuarios2(): Promise<any> {
    if (this.promisePending) {
        return this.listaUsuarios;
    }

    this.promisePending = true;

    try {
        const observable = this.http.get(this.URL + 'usuario/listaUsuarios', this.BS.getHeaders(true)).pipe(
            retryWhen(errors =>
                errors.pipe(
                    tap(val => console.log(`Attempt failed, retrying...`)),
                    delay(1000)
                )
            )
        );

        const ret: any = await firstValueFrom(observable);

        if (ret?.length) {
            this.listaUsuarios = ret;
            return ret;
        } else {
            throw new Error('Error ao buscar lista usuarios');
        }
    } catch (error) {
        console.log('error ao buscar usuários', error);
        throw error;
    } finally {
        this.promisePending = false;
    }
}

	/**
	 * Autenticação no P-Docs com credenciais do P-Docs.
	 */
	autenticaNoPDocs() {
		let milliseconds = new Date().getTime();
		let environment = this.ENV;
		// se está autenticado retorna a autenticação
		if (this.credenciaisPDocs?.expires - milliseconds > environment.pDocs.tempoReautenticacao) {
			return this.credenciaisPDocs;
		}
		// caso contrário autentica novamente e retorna a eutenticação
		else {
			return this.http.post(this.URL + 'usuario/login/pdocs', {}, this.BS.getHeaders(true)).toPromise();
		}
	}

	setCredenciaisPDocs(credenciais) {
		this.credenciaisPDocs = credenciais;
	}

	resetarSenha(usuarioId): Promise<any> {
		return this.http.post(this.URL + 'usuario/redefinir_senha', { usuarioId: usuarioId }, this.BS.getHeaders(true)).toPromise();
	}

	salvaUsuario(usuario): Promise<any> {
		return this.http.post(this.URL + 'usuario/createUpdate', usuario, this.BS.getHeaders(true)).toPromise();
	}

	buscaUsuario(usuarioId?: string): Promise<any> {
		if (!usuarioId) throw new Error('usuarioId não definido.');
		let path = 'usuario' + (usuarioId ? '/' + usuarioId.toString() : '');
		return this.http.get(this.URL + path, this.BS.getHeaders(true)).toPromise();
	}

	confirmaUsuario(confirmacao: string) {
		return this.http.post(this.URL + 'usuario/confirmacao', { chave: confirmacao }, this.BS.getHeaders()).toPromise();
	}

	redefinirPropriaSenha(body) {
		console.log('BODY', body);
		let ret = this.http.post(this.URL + 'usuario/muda_propria_senha', body, this.BS.getHeaders(true)).toPromise();
		let auth: any = this.getCredenciais();
		if (auth) {
			try {
				auth.senha = body.novaSenha;
				console.log('AUTH', auth);
				let retAuth = this.armazenaLogin(auth);
				console.log('Login efetuado', retAuth);

			} catch (error) {
				console.error(error);
			}
		}
		return ret;
	}

	reenviaEmail(body) {
		return this.http.post(this.URL + 'usuario/reenviaEmail', body, this.BS.getHeaders(true)).toPromise();
	}

	verificaLicenca() {
		let { assinaturaId, licenca, statusCorretora } = this.getCredenciais();
		if (assinaturaId && licenca) {
			let dataAtual = moment();
		let assinaturaVigente;
		if (Array.isArray(assinaturaId) && assinaturaId.length)
			assinaturaVigente = assinaturaId.find(assinatura => assinatura?.situacao == 1);
		else if (assinaturaId)
			assinaturaVigente = assinaturaId;
		if (!assinaturaVigente) {
			assinaturaVigente = assinaturaId?.[0];
		}
		let dtVencLicenca = moment(licenca).endOf('day');
		let dtVencLicencaHoras = dtVencLicenca.clone();
		if (assinaturaVigente?.pagamento?.meioPagamento == 'CREDITO') {
			dtVencLicencaHoras.add(1, 'days');
		}
		let diffDatas = dtVencLicenca.diff(dataAtual, 'day');
		let diffHoras = dtVencLicencaHoras.diff(dataAtual, 'hours');

		let result = {
			prazo: diffDatas,
			prazoHoras: diffHoras,
			formaPagamento: assinaturaVigente?.pagamento?.meioPagamento,
			status: this.getStatus(assinaturaVigente, dtVencLicenca),
			periodoTeste: diffDatas >= 0 && statusCorretora == 0,
			periodoLimitado: diffDatas < 0 && statusCorretora == 0
		};

		return result;
		}
		
	}

	getStatus(assinatura, licenca) {
		const isRenovacaoManualOrWaiting = assinatura?.renovacaoManual ||
			(assinatura?.pagamento?.status == 'waiting' &&
			this.moment(assinatura?.start_at).startOf('day').isAfter(this.moment(licenca).startOf('day')));

		let status;
		if (assinatura?.pagamento) {
			switch (assinatura?.pagamento?.status) {
				case 'paid':
					status = this.STATUS.PAGO;
					break;
				case 'waiting':
				case 'pending':
					status = isRenovacaoManualOrWaiting ? this.STATUS.PAGO : this.STATUS.PENDENTE;
					break;
				case 'fail':
					status = this.STATUS.CANCELADO_FALHA;
					break;
				default:
					status = this.STATUS.PENDENTE;
					break;
			}
		} else {
			status = assinatura?.status ? assinatura?.status : (this.credenciais?.root ? this.STATUS.PAGO : this.STATUS.PENDENTE);
		}

		return status;
	}

	async atualizaKeysPagamento() {

		let assinatura: any
		try {
			assinatura = await this.apiEbs.dadosAssinaturaDBApice();
		} catch (error) {
			console.log(error);
		}
		let credenciais = this.getCredenciaisCrypto();
		credenciais.assinaturaId = assinatura?.assinaturaId;
		credenciais.licenca = assinatura?.licenca;
		credenciais.statusCorretora = assinatura.statusCorretora;
		this.armazenaLogin(credenciais);
		this.verificaLicenca();
		setTimeout(() => {
			this.autenticado.next(true);
		}, 2000);

	}

	criarTicket(body) {
		if (this.ENV.production) {
			return this.http.post(this.URL + "usuario/criarTicket", body, this.BS.getHeaders(true)).toPromise();
		}
	}

	public async verificaCorretoraMigrada() {

		const ambiente = environment.production ? 'https://aggilizador.com.br' : 'https://dev.aggilizador.com.br';
	
			const confirmacao = await this.utilsService.createAlertAggilizador(
				'Novo Aggilizador Web',
				`Sua Corretora foi migrada e agora o acesso ao seu multicálculo será pelo Novo Aggilizador!<br>
				Basta acessar o Novo Aggilizador em <a href="${ambiente}">${ambiente}</a><br>
				Clique em OK e você será redirecionado automaticamente.`,
				null,
				'static',
				false
			);
	
			if (confirmacao) {
				window.location.href = ambiente;
			}
	}
	
}
